import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import "./Login.css";
import Avtar from "./img/avatar.svg";
import Bg from "./img/bg.svg";
import WaveImg from "./img/wave.png";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import ErrorIcon from "@mui/icons-material/Error";
import { MAIN_URL } from "../../data/const";
const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      console.log("login", email, password);
      await login({ email, password });

      // Redirect to the protected page they tried to visit or home
      const from = location.state?.from?.pathname || "/";
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred during login");
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = (e) => {
    e.preventDefault();
    setShowPassword(!showPassword);
  };

  return (
    <div className="auth-container">
      <img className="wave" src={WaveImg} alt="background wave" />
      <div className="container">
        <div className="img">
          <img src={Bg} alt="background decoration" />
        </div>
        <div className="login-content">
          <form onSubmit={handleSubmit} className="auth-form">
            <img src={Avtar} alt="avatar" className="auth-avatar" />
            <h2 className="title">Owner Login</h2>

            {error && (
              <div className="error-message">
                <ErrorIcon className="error-icon" />
                {error}
              </div>
            )}

            <div className="input-div one">
              <div className="i">
                <PersonIcon className="input-icon" />
              </div>
              <div className="div">
                <input
                  placeholder="Email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="input"
                  disabled={isLoading}
                  required
                />
              </div>
            </div>

            <div className="input-div pass">
              <div className="i">
                <LockIcon className="input-icon" />
              </div>
              <div className="div password-input-container">
                <input
                  placeholder="Password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="input"
                  disabled={isLoading}
                  required
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="password-toggle"
                  tabIndex="-1"
                >
                  {showPassword ? (
                    <VisibilityOffIcon className="visibility-icon" />
                  ) : (
                    <VisibilityIcon className="visibility-icon" />
                  )}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className={`btn login-btn ${isLoading ? "loading" : ""}`}
              disabled={isLoading}
            >
              {isLoading ? "Logging in..." : "Login"}
            </button>

            <div className="additional-links">
              <a href="/forgot-password" className="auth-link">
                Forgot Password?
              </a>
              <a
                href={`${MAIN_URL}/api/v1/owner/register`}
                className="auth-link"
              >
                Create Account
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
